/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBrowser: {
  name: 'browser';
  data: string;
} = {
  name: 'browser',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2Zm12.5 6V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v4.5h13Zm-13 1h13V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7.5ZM8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
